import React, { useState } from 'react';
import { SalesObjectLevel } from '../level/SalesObjectLevel';
import { Box } from '@mui/material';
import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';
import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../../components/special/updateOrCreate';
import ExoDialog from '../../../components/exo/ExoDialog';
import { NewSalesLevel } from '../../../components/new/NewSalesLevel';

export const SalesObjectLevelTab = ({
  inEditMode,
  setApiData,
  apiData,
  salesObjectId,
  onPropsChange,
}) => {
  const { t } = useTranslation();

  const [openNewLevel, setOpenNewLevel] = useState(false);
  const [editLevel, setEditLevel] = useState(null);

  const { levels, supervisor, properties } = apiData?.data;

  function handleLevelChange(newLevel) {
    setOpenNewLevel(false);
    const newLevels = updateOrCreate(apiData.data.levels, newLevel.data, true);
    setApiData({ ...apiData, data: { ...apiData.data, levels: newLevels } });
    setEditLevel(null);
  }

  function handleDeletedLevel(level) {
    const newLevels = apiData.data.levels.filter((obj) => obj.id !== level.id);
    setApiData({ ...apiData, data: { ...apiData.data, levels: newLevels } });
  }

  return (
    <Box className="flex flex-col h-full overflow-y-auto gap-4 w-full">
      <Box className="flex flex-col justify-between min-h-full gap-2">
        <Box className="w-full flex flex-col gap-4">
          {levels.map((lvl) => (
            <SalesObjectLevel
              key={lvl.id}
              data={lvl}
              onChange={handleLevelChange}
              onDelete={handleDeletedLevel}
              onEdit={(level) => {
                setOpenNewLevel(true);
                setEditLevel(level);
              }}
              isEditMode={inEditMode}
              objectProperties={properties}
              salesObjectId={salesObjectId}
              onPropsChange={onPropsChange}
            />
          ))}
          {inEditMode && (
            <ProjectAddElementButton
              label={t('Add Level')}
              onClick={() => setOpenNewLevel(true)}
            />
          )}
        </Box>
      </Box>
      <ExoDialog
        open={openNewLevel}
        limitWidth
        onClose={() => {
          setEditLevel(null);
          setOpenNewLevel(false);
        }}
      >
        <NewSalesLevel
          startData={editLevel}
          onUpdate={handleLevelChange}
          onCreate={handleLevelChange}
          onClose={() => {
            setEditLevel(null);
            setOpenNewLevel(false);
          }}
          salesObjectId={salesObjectId}
        />
      </ExoDialog>
    </Box>
  );
};
